import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from '@/components/ui/dropdown-menu';

interface LanguageSelectorProps {
  className?: string;
}

export default function LanguageSelector({ className }: LanguageSelectorProps) {
  const { currentLanguage, changeLanguage } = useLanguage();
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className={`flex items-center gap-1 text-white hover:bg-white/10 ${className}`} 
          aria-label="Select language"
        >
          <Globe className="h-4 w-4" />
          <span className="uppercase">{currentLanguage}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white/20 backdrop-blur-md border border-white/30">
        <DropdownMenuItem 
          onClick={() => changeLanguage('da')}
          className={`text-white hover:bg-white/20 ${currentLanguage === 'da' ? 'bg-white/30' : ''}`}
        >
          <span className="font-medium">Dansk</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => changeLanguage('en')}
          className={`text-white hover:bg-white/20 ${currentLanguage === 'en' ? 'bg-white/30' : ''}`}
        >
          <span className="font-medium">English</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}